import {
  Component,
  OnInit,
  OnDestroy,
  AfterViewInit,
  ChangeDetectorRef,
  Renderer2,
  inject,
  DOCUMENT,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppService } from '@core/services/app.service';
import { ContactoAsistenciaResultDto } from '@core/interfaces/home/contacto-asistencia';
import { EntityEnum } from '@core/enums/entity.enum';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [CommonModule, NgxMaskPipe],
  providers: [provideNgxMask()],
})
export class FooterComponent implements OnInit, AfterViewInit, OnDestroy {
  private appService = inject(AppService);
  private cdr = inject(ChangeDetectorRef);
  private renderer = inject(Renderer2);
  private document = inject(DOCUMENT);

  private scrollY = 0;
  private unlisten: (() => void)[] = [];

  currentYear: number = new Date().getFullYear();

  contactInfo = {
    phone: '',
    email: '',
    horario: '',
    direccion: '',
    mapUrlSantoDomingo: '',
    direccionSantiago: '',
    mapUrlSantiago: '',
  };

  socialLinks = [
    { icon: 'assets/icons/facebook.svg', url: '', label: 'Facebook' },
    { icon: 'assets/icons/instagram.svg', url: '', label: 'Instagram' },
    { icon: 'assets/icons/whatsapp.svg', url: '', label: 'WhatsApp' },
    { icon: 'assets/icons/youtube.svg', url: '', label: 'YouTube' },
    { icon: 'assets/icons/linkedin.svg', url: '', label: 'LinkedIn' },
  ];

  footerLinks = [
    { text: 'Políticas de privacidad', key: 'politicas-privacidad' },
    { text: 'Términos y condiciones', key: 'terminos-condiciones' },
    { text: 'Políticas de uso', key: 'politicas-uso' },
    { text: 'Uso de los cookies', key: 'uso-cookies' },
  ];

  activeModal: string | null = null;
  activeModalTitle: string = '';

  openModal(key: string, title: string): void {
    this.activeModal = key;
    this.activeModalTitle = title;
  }

  ngOnInit(): void {
    this.loadContactInfo();
  }

  ngAfterViewInit(): void {
    const modal = this.document.getElementById('footerContentModal');
    if (!modal) return;

    this.unlisten.push(
      this.renderer.listen(modal, 'show.bs.modal', () => {
        this.scrollY = window.scrollY;
        this.renderer.setStyle(this.document.documentElement, 'overflow', 'hidden');
      }),
      this.renderer.listen(modal, 'hidden.bs.modal', () => {
        this.renderer.removeStyle(this.document.documentElement, 'overflow');
        window.scrollTo({ top: this.scrollY, behavior: 'instant' });
      }),
    );
  }

  ngOnDestroy(): void {
    this.unlisten.forEach((fn) => fn());
    this.renderer.removeStyle(this.document.documentElement, 'overflow');
  }

  private loadContactInfo(): void {
    this.appService.getContactoAsistencia(EntityEnum.AFP_POPULAR).subscribe({
      next: (response) => {
        if (response) {
          this.updateContactInfo(response);
          this.cdr.detectChanges();
        }
      },
      error: () => {
        this.cdr.detectChanges();
      },
    });
  }

  private updateContactInfo(data: ContactoAsistenciaResultDto): void {
    this.contactInfo = {
      phone: data.telefono,
      email: data.email,
      horario: data.horario,
      direccion: data.direccion,
      mapUrlSantoDomingo: `https://www.google.com/maps/search/AFP+Popular/@${data.latitud},${data.longitud},17z`,
      direccionSantiago: data.direccionSucursalSantiago,
      mapUrlSantiago: `https://www.google.com/maps/search/AFP+Popular+Santiago/@${data.latitudSucursalSantiago},${data.longitudSucursalSantiago},17z`,
    };
    this.socialLinks = [
      { icon: 'assets/icons/facebook.svg', url: data.urlFacebook, label: 'Facebook' },
      { icon: 'assets/icons/instagram.svg', url: data.urlInstagram, label: 'Instagram' },
      { icon: 'assets/icons/whatsapp.svg', url: data.urlWhatsapp, label: 'WhatsApp' },
      { icon: 'assets/icons/youtube.svg', url: data.urlYoutube, label: 'YouTube' },
      { icon: 'assets/icons/linkedin.svg', url: data.urlLinkedin, label: 'LinkedIn' },
    ];
  }
}
